import BarChart from './BarChart.vue';

export default BarChart;
